import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import type { BatchStock } from '../../../models/Batch';

interface StockByLocationProps {
  stock: BatchStock[];
  isLoading: boolean;
}

export const StockByLocation = ({ stock, isLoading }: StockByLocationProps) => {
  const { t } = useTranslation('batchesModule');

  const total = stock.reduce((sum, s) => sum + s.quantity, 0);

  return (
    <section className="rounded-lg border border-card-border p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <FontAwesomeIcon icon={faLocationDot} className="w-4 h-4 text-complementary-text" />
          <h2 className="text-lg font-semibold">{t('detail.stock.title')}</h2>
        </div>
        <span className="text-sm text-primary">{t('detail.stock.locations_count', { count: stock.length })}</span>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary" />
        </div>
      ) : stock.length === 0 ? (
        <p className="text-sm text-complementary-text text-center py-4">{t('detail.stock.no_stock')}</p>
      ) : (
        <table className="w-full">
          <thead>
            <tr className="border-b border-card-border">
              <th className="text-left text-xs font-medium text-complementary-text uppercase py-2 px-2">
                {t('detail.stock.location_code')}
              </th>
              <th className="text-right text-xs font-medium text-complementary-text uppercase py-2 px-2">
                {t('detail.stock.quantity')}
              </th>
            </tr>
          </thead>
          <tbody>
            {stock.map((item) => (
              <tr key={item.location_id} className="border-b border-card-border/50">
                <td className="py-3 px-2">
                  <div className="flex items-center gap-2">
                    <FontAwesomeIcon icon={faLocationDot} className="w-3 h-3 text-complementary-text" />
                    <span className="text-sm text-text">{item.location_code}</span>
                  </div>
                </td>
                <td className="text-right py-3 px-2">
                  <span className="text-sm font-medium text-text">
                    {item.quantity} {t('detail.stock.units')}
                  </span>
                </td>
              </tr>
            ))}
            <tr>
              <td className="py-3 px-2">
                <span className="text-sm font-semibold text-text">{t('detail.stock.total')}</span>
              </td>
              <td className="text-right py-3 px-2">
                <span className="text-sm font-bold text-text">
                  {total} {t('detail.stock.units')}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </section>
  );
};
